import Header from '../header'
export default function Daycare() {
    return <div className=' boardingTitle'>
        <div className='colorpage'>
            <Header />
        </div>

        <div className="container-fluid">


            <div className="row">
                <div className="col-lg-6">
                    <h1 className="headlines">PMpaws's </h1>
                    <h1 className="boardheadlines">DAYCARE </h1>
                    <p className="paragraph">At PmPaws, we are unique at what we do. We love and care for your pup like they are our own. We realize that your dog is a furry member of your family and they deserve the highest level of quality care.  We provide daycare/spa section for your dog, providing safe socialization, education and exercise. We firmly believe that every dog deserves to be cared for! We will provide progress reports through report cards and conversations with you as a caring pet parent. Besides providing a safe environment for your pup, PmPaws is known for treating your pup to their Most Day Ever!</p>


                </div>
                <div className="col-lg-6">
                    <img className="titleimageday" src="images/fac.jpg" alt="iphone-mockup" />


                </div>
            </div>

            <div className="row pt-5">
                <div className="col-lg-6 ">
                    <h1 className="headlines  ">THE BENEFITS OF</h1>
                    <h1 className="boardheadlines">DOG DAYCARE</h1>
                    <p className="paragraph">Wanting to be social is deeply instinctual for dogs; that is why we integrate open play with others into their daily routine. Regular playtime with other dogs has numerous benefits, including:</p>
                    <ul>
                        <li>Spa Baths</li>
                        <li>Brush Outs</li>
                        <li>Ear Cleaning</li>
                        <li>Teeth Brushing</li>
                        <li>Grooming (availability varies by location)</li>
                    </ul>


                    <h1 className="headlines  ">PmPaws</h1>
                    <h1 className="boardheadlines">DOG SPA Services</h1>

                    <p className='paragraph'>Our caring team creates a relaxing environment for your dog in our modern spa facilities, which are designed to cater to the comfort of our furry guests. For example, we realize that many dogs may get nervous around loud noises; that’s why we offer a variety of drying methods, such as crate hair dryers or handheld options.

                        Our dog spa is fully stocked with hypoallergenic shampoos, conditioners and products designed specifically to be safe and gentle on a dog's skin and coat. Our spa attendants are highly trained at handling dogs of all sizes and breeds, and know how to put your pup at ease during any treatment.</p>


                    <p className="paragraph">Pamper your pup with PmPaw's doggie spa services, including: </p>
                        <ul>
                            <li>Learning positive behavior, leading to less doggie mischief at home</li>
                            <li>Finding their Best Furry Friend Forever </li>
                            <li>Staying physically fit. Pet obesity is a growing concern; according to the Association for Pet Obesity Prevention, more than 50 percent of dogs are obese</li>
                            <li>Being more comfortable around dogs and people</li>

                        </ul>

                   

                </div>
                <div className="col-lg-6 pt-5">
                    <div className="typhography pt-5">

                        <h3 className='textorg text-green pt-5'>

                            <em className='text-orange'>Squealy </em>
                            CLEAN,
                            <em className='text-secondary'> smelling</em>
                            <em className='text-orange'> FRESH</em>
                            <em className='text-secondary'> and</em>
                            <em className='text-wit'> looking like a</em>
                            <em className='text-success'> fresh Snack</em>
                            

                        </h3>
                    </div>
                    <img className="titleimageboarding" src="images/star.JPG" alt="iphone-mockup" />


                </div>
            </div>



            <div className="row pt-5">
                <div className="col-lg-6 ">


                    <img className="titleimageboarding" src="images/fac.jpg" alt="iphone-mockup" />

                    <div  >



                    </div>
                </div>


                <div className="col-lg-6 pt-5">


                    <h1 className='textorg text-tomred pt-5'>

                        <span className='text-secondary'>Treat</span>
                        YOURSELF
                        <span className='text-secondary'> to the  </span>
                        <span className='text-orange'> LOVE </span>
                        <span className='text-green'>   You Deserve</span>


                    </h1>
                    <h3 className='textorg text-green pt-5'>

                        <span className='text-secondary'>Play </span>
                        without worry
                        <span className='text-secondary'> in the</span>
                        <span className='text-orange'> SAFEST</span>
                        <span className='text-secondary'> Place</span>


                    </h3>

                </div>
            </div>
        </div>
        {/* <!-- Footer -->  */}


        <footer id="footer"   >
            <div className='footerPositioning' >
                <a href="/posh"> <i className="social-icon fab fa-facebook-square"></i></a>
                <a href="https://twitter.com/Posh_Mo"><i className="social-icon fab fa-twitter-square"></i></a>
                <a href="https://www.instagram.com/posh_mo/"><i className="social-icon fab fa-instagram"></i></a>
                <a href="mailto: ispeakfordogs@yahoo.com? subject = Feedback&body = Message"> <i className="social-icon fas fa-envelope-square"></i></a>
                <p>© Copyright PmPaws</p>
            </div>
        </footer>


    </div>



}

